import React from 'react';
import Header from './header';
import Footer from './footer';

const PrivacyPolicy = () => {
  return (
    <div>
      <Header />
      <div className="container" style={{ padding: '80px 20px', maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ color: '#2e3192', marginBottom: '30px', fontSize: '32px', fontWeight: 'bold' }}>
          KnackVibes – Privacy Policy & Terms of Service
        </h1>

        {/* Privacy Policy Section */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{ color: '#2e3192', marginBottom: '20px', fontSize: '28px', fontWeight: 'bold' }}>
            Privacy Policy
          </h2>
          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            KnackVibes ("we", "our", "us") respects your privacy and is committed to protecting user information. This Privacy Policy explains how we collect, use, and protect your data.
          </p>

          <h3 style={{ color: '#2e3192', marginTop: '25px', marginBottom: '15px', fontSize: '22px', fontWeight: '600' }}>
            Information We Collect:
          </h3>
          <ul style={{ marginBottom: '20px', paddingLeft: '25px', lineHeight: '1.8', color: '#333' }}>
            <li>Name, email, and profile picture via Facebook Login</li>
            <li>Facebook Pages and Instagram Business accounts you connect</li>
            <li>Access tokens required for publishing content (stored securely)</li>
          </ul>
          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            We do not access personal posts, friends lists, private messages, or follower data.
          </p>

          <h3 style={{ color: '#2e3192', marginTop: '25px', marginBottom: '15px', fontSize: '22px', fontWeight: '600' }}>
            How We Use Information:
          </h3>
          <ul style={{ marginBottom: '20px', paddingLeft: '25px', lineHeight: '1.8', color: '#333' }}>
            <li>Authenticate users</li>
            <li>Publish and schedule posts to Facebook Pages and Instagram Business accounts</li>
            <li>Display engagement metrics</li>
          </ul>

          <h3 style={{ color: '#2e3192', marginTop: '25px', marginBottom: '15px', fontSize: '22px', fontWeight: '600' }}>
            Data Security:
          </h3>
          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            All tokens are securely stored and encrypted. Users can disconnect accounts at any time, which revokes access.
          </p>

          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            <strong>Contact:</strong> <a href="mailto:vibes@knackhook.com" style={{ color: '#2e3192' }}>vibes@knackhook.com</a>
          </p>
        </section>

        {/* Terms of Service Section */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{ color: '#2e3192', marginBottom: '20px', fontSize: '28px', fontWeight: 'bold' }}>
            Terms of Service
          </h2>
          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            By accessing or using KnackVibes, you agree to these Terms of Service.
          </p>

          <h3 style={{ color: '#2e3192', marginTop: '25px', marginBottom: '15px', fontSize: '22px', fontWeight: '600' }}>
            Service Description:
          </h3>
          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            KnackVibes is a social media management platform that allows users to connect Facebook Pages and Instagram Business accounts to create, schedule, and publish content. Personal profiles are not supported.
          </p>

          <h3 style={{ color: '#2e3192', marginTop: '25px', marginBottom: '15px', fontSize: '22px', fontWeight: '600' }}>
            User Responsibilities:
          </h3>
          <ul style={{ marginBottom: '20px', paddingLeft: '25px', lineHeight: '1.8', color: '#333' }}>
            <li>Use the platform only for lawful purposes</li>
            <li>Ensure you have authorization to manage connected social accounts</li>
            <li>Comply with Facebook and Instagram platform policies</li>
          </ul>

          <h3 style={{ color: '#2e3192', marginTop: '25px', marginBottom: '15px', fontSize: '22px', fontWeight: '600' }}>
            Content Ownership:
          </h3>
          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            Users retain full ownership of content they create or publish.
          </p>

          <h3 style={{ color: '#2e3192', marginTop: '25px', marginBottom: '15px', fontSize: '22px', fontWeight: '600' }}>
            Account Suspension or Termination:
          </h3>
          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            KnackVibes may suspend or terminate accounts in cases of policy violations, misuse, or legal requirements.
          </p>

          <h3 style={{ color: '#2e3192', marginTop: '25px', marginBottom: '15px', fontSize: '22px', fontWeight: '600' }}>
            Limitation of Liability:
          </h3>
          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            KnackVibes is provided "as is" and is not responsible for third-party platform issues, API limitations, or data loss.
          </p>

          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            <strong>Contact:</strong> <a href="mailto:vibes@knackhook.com" style={{ color: '#2e3192' }}>vibes@knackhook.com</a>
          </p>
        </section>

        {/* Data Deletion and User Rights Section */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{ color: '#2e3192', marginBottom: '20px', fontSize: '28px', fontWeight: 'bold' }}>
            Data Deletion and User Rights
          </h2>
          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            Users have the right to request deletion of their account and all associated data at any time.
          </p>
          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            To request data deletion, users must send an email to <a href="mailto:vibes@knackhook.com" style={{ color: '#2e3192' }}>vibes@knackhook.com</a> from the email address associated with their KnackVibes account.
          </p>
          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            Upon receiving a valid deletion request, KnackVibes will permanently delete all user data, including but not limited to:
          </p>
          <ul style={{ marginBottom: '20px', paddingLeft: '25px', lineHeight: '1.8', color: '#333' }}>
            <li>User ID</li>
            <li>Email address</li>
            <li>Profile information</li>
            <li>Saved preferences and settings</li>
            <li>Connected Facebook Pages and Instagram account IDs</li>
            <li>Access tokens and authentication credentials</li>
            <li>Post drafts, scheduled posts, published posts, and posting history</li>
            <li>Usage logs and related account data</li>
          </ul>
          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            All requested data deletion will be completed within seven (7) business days from the date of request confirmation.
          </p>
          <p style={{ marginBottom: '20px', lineHeight: '1.8', color: '#333' }}>
            Once the deletion process is completed, the data cannot be recovered. KnackVibes does not retain any Platform Data or user-related information after deletion, except where retention is required by law.
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;

